import React from 'react'
import { useUIState, useConfigState } from '@sentecacommerce-theme/lib'
import dynamic from 'next/dynamic'
import {
  GDPRModalProps,
  AuthPopupProps,
  AddressFormModalProps,
} from '../Modals'

import { Spinner } from '..'

export const Views = () => {
  const { views } = useUIState()
  const config = useConfigState()
  const viewsMap: any = React.useMemo(() => {
    return {
      [config.views.auth]: dynamic<AuthPopupProps>(
        () => import('../Modals').then((mod) => mod.AuthPopup),
        {
          loading: () => <Spinner />,
          ssr: false,
        }
      ),
      [config.views.gdprModal]: dynamic<GDPRModalProps>(
        () => import('../Modals').then((mod) => mod.GDPRModal),
        {
          loading: () => <Spinner />,
          ssr: false,
        }
      ),
      [config.views.checkoutBasketPreview]: dynamic<{}>(
        () => import('../Modals').then((mod) => mod.CheckoutPreviewModal),
        {
          loading: () => <Spinner />,
          ssr: false,
        }
      ),
      [config.views.addressForm]: dynamic<AddressFormModalProps>(
        () => import('../Modals').then((mod) => mod.AddressFormModal),
        {
          loading: () => <Spinner />,
          ssr: false,
        }
      ),
    }
  }, [])

  return (
    <>
      {views?.map((item) => {
        return React.createElement(viewsMap[item.id], {
          ...item.props,
          key: item.id,
        })
      })}
    </>
  )
}
